import React from "react";
import "../css/modal.css";
import { useState, useEffect } from "react";
import Notificacion from "./Notificacion";
import { getNotificationPage } from '../../Api/content'
import { useLocale } from '../../i18n/localeContext'

function ModalNotificaciones({ notificaciones, estado, cambiarEstado }) {
  const [notificationPage, setNotificationPage] = useState(null);
  const { locale } = useLocale();

  const [detailState, changeDetailState] = useState({ titulo: '', cuerpo: '', display: false });

  useEffect(() => {
    let cancel = false;
    getNotificationPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) setNotificationPage(data);
      })
      .catch(() => { if (!cancel) setNotificationPage(null) });
    return () => { cancel = true };
  }, [locale])

  return (
    <>
      <div className={estado ? "active notifContainer" : "notifContainer"}>
        <div className="notifTitle">
          <h3>{notificationPage?.title || "Notificaciones"}</h3>
          <button onClick={() => cambiarEstado(false)} className="btnCloseModal">
            <i className="material-icons"></i>
          </button>
        </div>

        {notificaciones.length != 0 ? (
          <div className="notifBody">
            {notificaciones.map((item, i) => {
              return (
                <div key={i} className="notifHeader">
                  <div className="notifInfo">
                    <h3>{item.asunto}</h3>
                    <h3>{item.fecha}</h3>
                    <p>{item.cuerpo}</p>
                  </div>
                  <button onClick={() => { changeDetailState({ titulo: item.asunto, cuerpo: item.cuerpo, display: true }); cambiarEstado(false) }}>
                    <i className="material-icons"></i>
                  </button>
                </div>
              );
            })}

          </div>
        ) : (
          <div className="message-container">
            <span className="message">{notificationPage?.noNotification || "No tiene notificaciones"} 🔕🔕🔕</span></div>
        )
        }

      </div>
      <Notificacion
        display={detailState.display}
        cambiarEstado={changeDetailState}
        titulo={notificationPage?.subtitle || "Detalle"}
        cuerpo={detailState.cuerpo}
        cambiarEstadoPadre={cambiarEstado}
      />
    </>
  );
}

export default ModalNotificaciones;
